// extracted by mini-css-extract-plugin
module.exports = {"partner":"Partner_partner__1ART8","displayNone":"Partner_displayNone__2trwp"};